import apiClient from '@/services/axios'

export async function del(certificateId) {
  var response = await apiClient.delete('/certificates/' + certificateId)
  if (response) {
    return response.data
  }

  throw new Error('Unable to add certificate.')
}